import React from "react";
import TableHeader from "./tableHeader";
import TableBody from "./tableBody";
import TableFooter from "./tableFooter";
//...rest === {, keyId, handleDelete, handleChange, hardness, finishes}
const Table = ({
  columns,
  id,
  data,
  countTotal,
  fcolumns,
  fcolumns2,
  fcolumns3,
  ...rest
}) => {
  return (
    <div className="table-responsive">
      <table className="table" id={id ? id : "table"}>
        <TableHeader columns={columns} />
        <TableBody columns={columns} data={data} {...rest} />
        <TableFooter
          data={data}
          countTotal={countTotal}
          columns={fcolumns}
          columns2={fcolumns2 ? fcolumns2 : []}
          columns3={fcolumns3 ? fcolumns3 : []}
        />
      </table>
    </div>
  );
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/Common/table.jsx